var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5H3.5M6.5 11H2M9 5.5H4M17 2L10.4036 11.235C10.1116 11.6438 9.96562 11.8481 9.97194 12.0185C9.97744 12.1669 10.0486 12.3051 10.1661 12.3958C10.3011 12.5 10.5522 12.5 11.0546 12.5H16L15 20L21.5964 10.765C21.8884 10.3562 22.0344 10.1519 22.0281 9.98147C22.0226 9.83312 21.9514 9.69489 21.8339 9.60418C21.6989 9.5 21.4478 9.5 20.9454 9.5H16L17 2Z",
    stroke: "#F4FBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapFast);
export default __webpack_public_path__ + "static/media/zap-fast.789a98c95435e29ed25ffcf0d18c3a77.svg";
export { ForwardRef as ReactComponent };